import { noop } from 'lodash';
import { getLanguage } from '../base-params/base-params-selectors';
import { createPromisifiedAction } from '../promisified-actions/create-promisified-action';
export function requestLogin(payload) {
    return (_dispatch, getState, { wixCodeApi }) => {
        const options = {
            lang: getLanguage(getState()),
            modal: true,
            mode: payload.mode,
        };
        return wixCodeApi.user.promptLogin(options).catch(noop);
    };
}
export const requestLoginPromisified = createPromisifiedAction(requestLogin, () => null);
//# sourceMappingURL=request-login.js.map